export default __webpack_public_path__ + "static/media/Short_Skyline.6fe39f9d.svg";